import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Select, Form, Checkbox, notification, Icon, Input, Modal } from "antd";
import axios from "axios";
import moment from "moment";

import DrawerDetalhe from "./DrawerDetalhe";
import InitialsAvatar from "../../../shared/components/InitialsAvatar";

import { GlobalContext } from "../../../app/providers/GlobalState";

const { Option } = Select;
const confirm = Modal.confirm;
const warning = Modal.warning;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Frequencia extends Component {
    static contextType = GlobalContext;

    state = {
        //DRAWER PRESENÇAS
        dt_inicio: "",
        falta: false,
        mostrarObservacoes: false,
        presenca: false,
        presencas: [],
        presencasEstadoOriginal: [],
        observacoes: "",
        participantes: [],
        assiduidadesInvalidas: [],
        aplicar: false,
        loadingParticipantes: false,
        //LOADING
        iconLoading: false,
        //DRAWER DETALHE
        visivel: false,
        info: "",
        ficheiro: [],
        ficheiros: []
    };

    debounceTimerPresencas = null;
    debounceTimerObservacoes = null;
    debounceTimerAplicar = null;
    autoSaveTimeout = null;
    backupRascunho = null;
    alteradoPeloUser = false;

    componentWillUnmount() {
        // Limpar todos os timers quando o componente for desmontado
        if (this.debounceTimerPresencas) {
            clearTimeout(this.debounceTimerPresencas);
        }
        if (this.debounceTimerObservacoes) {
            clearTimeout(this.debounceTimerObservacoes);
        }
        if (this.debounceTimerAplicar) {
            clearTimeout(this.debounceTimerAplicar);
        }
        if (this.autoSaveTimeout) {
            clearTimeout(this.autoSaveTimeout);
        }
    }

    componentDidMount() {
        this.listar();
    }

    ultimoAulaDiario = localStorage.getItem("aula_diario");

    componentDidUpdate(prevProps, prevState) {
        const aulaDiarioAtual = localStorage.getItem("aula_diario");

        if (this.ultimoAulaDiario !== aulaDiarioAtual) {
            this.listar();

            this.ultimoAulaDiario = aulaDiarioAtual;
        }

        if (this.props.frequenciaExcluido) {
            this.props.form.resetFields();
            const novasPresencas = this.state.presencas.map(presenca => {
                return {
                    ...presenca,
                    estado: "",
                    observacoes: ""
                };
            });

            this.setState({
                falta: false,
                presenca: false,
                presencas: novasPresencas,
                observacoes: "",
                mostrarObservacoes: false
            });
            this.props.resetFrequenciaExcluido();
        }

        // Debounce para mudanças em presencas
        if (prevState.presencas.length !== this.state.presencasEstadoOriginal.length && prevState.presencas !== this.state.presencas) {
            this.debouncePresencas();
        }

        // Debounce para mudanças em observacoes
        if (prevState.observacoes !== this.state.observacoes) {
            this.debounceObservacoes();
        }

        // Debounce para mudanças em aplicar
        if (prevState.aplicar !== this.state.aplicar) {
            this.debounceAplicar();
        }

        // Verificar mudanças em presenca e falta coletiva
        if (prevState.presenca !== this.state.presenca || prevState.falta !== this.state.falta) {
            this.iniciarAutoSave();
        }
    }

    debouncePresencas = () => {
        if (this.debounceTimerPresencas) {
            clearTimeout(this.debounceTimerPresencas);
        }

        this.debounceTimerPresencas = setTimeout(() => {
            this.iniciarAutoSave();
        }, 300);
    };

    debounceObservacoes = () => {
        if (this.debounceTimerObservacoes) {
            clearTimeout(this.debounceTimerObservacoes);
        }

        this.debounceTimerObservacoes = setTimeout(() => {
            this.iniciarAutoSave();
        }, 300);
    };

    debounceAplicar = () => {
        if (this.debounceTimerAplicar) {
            clearTimeout(this.debounceTimerAplicar);
        }

        this.debounceTimerAplicar = setTimeout(() => {
            this.iniciarAutoSave();
        }, 300);
    };

    iniciarAutoSave = () => {
        this.alteradoPeloUser = true;

        if (this.autoSaveTimeout) {
            clearTimeout(this.autoSaveTimeout);
        }

        this.autoSaveTimeout = setTimeout(() => {
            this.tentarGuardarRascunho();
        }, 500);
    };

    tentarGuardarRascunho = () => {
        if (!this.alteradoPeloUser) return;
        this.guardarRascunhoFrequencia();
        this.alteradoPeloUser = false;
    };

    criarBackupRascunho = () => {
        this.backupRascunho = {
            presencas: JSON.parse(JSON.stringify(this.state.presencas)),
            observacoes: this.state.observacoes,
            aplicar: this.state.aplicar,
            presenca: this.state.presenca,
            falta: this.state.falta,
            ficheiros: JSON.parse(JSON.stringify(this.state.ficheiros))
        };
    };

    verificarAlteracaoRascunho = () => {
        if (!this.backupRascunho) return true;

        const backup = this.backupRascunho;

        const normalize = val => {
            if (val === null || val === undefined) return null;
            if (typeof val === "string") return val.trim();
            return val;
        };

        const atual = {
            presencas: JSON.stringify(this.state.presencas),
            observacoes: normalize(this.state.observacoes),
            aplicar: this.state.aplicar,
            presenca: this.state.presenca,
            falta: this.state.falta,
            ficheiros: JSON.stringify(this.state.ficheiros)
        };

        const backupNormalizado = {
            presencas: JSON.stringify(backup.presencas),
            observacoes: normalize(backup.observacoes),
            aplicar: backup.aplicar,
            presenca: backup.presenca,
            falta: backup.falta,
            ficheiros: JSON.stringify(backup.ficheiros || [])
        };

        return JSON.stringify(atual) !== JSON.stringify(backupNormalizado);
    };

    guardarRascunhoFrequencia = async (ficheiroRemovidoId = null) => {
        const aulaId = localStorage.getItem("aula_diario");
        if (!aulaId) return;

        const houveAlteracao = this.verificarAlteracaoRascunho();
        if (!houveAlteracao) {
            return;
        }

        const item = new FormData();
        item.append("id", aulaId);
        item.append("presencas_rascunho", JSON.stringify(this.state.presencas));
        item.append("observacoes_rascunho", this.state.observacoes || "");
        item.append("aplicar_rascunho", this.state.aplicar);
        item.append("presenca_coletiva_rascunho", this.state.presenca);
        item.append("falta_coletiva_rascunho", this.state.falta);

        const participantes = this.state.presencas.filter(precensa => precensa.ficheiro != null);

        participantes.forEach(participante => {
            item.append(`ficheiro_${participante.id}`, participante.ficheiro[0]);
        });

        if (ficheiroRemovidoId) {
            item.append("ficheiro_removido_id", ficheiroRemovidoId);
        }

        axios({
            method: "put",
            url: "/api/aulas/rascunho-frequencia-aula",
            data: item
        })
            .then(() => {
                // Atualizar o backup após guardar com sucesso
                this.backupRascunho = {
                    presencas: JSON.parse(JSON.stringify(this.state.presencas)),
                    observacoes: this.state.observacoes,
                    aplicar: this.state.aplicar,
                    presenca: this.state.presenca,
                    falta: this.state.falta
                };

                this.buscarFicheirosRascunho();

                this.context.atualizarState({
                    existeRascunhoGuardado: true
                });
            })
            .catch(error => {
                console.error("Erro ao guardar rascunho de frequência:", error);
                openNotificationWithIcon(
                    "error",
                    "Erro ao guardar",
                    "Ocorreu um problema ao guardar o rascunho da frequência. Tente novamente."
                );

                this.context.atualizarState({
                    existeRascunhoGuardado: false
                });
            });
    };

    cancelarRascunho = () => {
        axios({
            method: "delete",
            url: "/api/aulas/rascunho-frequencia-aula",
            params: { aulaId: localStorage.getItem("aula_diario") }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    carregarRascunhoFrequencia = () => {
        const aulaId = localStorage.getItem("aula_diario");
        if (!aulaId) return;

        axios({
            method: "get",
            url: "/api/aulas/rascunho-frequencia-aula",
            params: {
                aulaId: aulaId
            }
        })
            .then(response => {
                const isEmpty = v => v === null || v === undefined || (typeof v === "string" && v.trim() === "");

                const semRascunhoBase = isEmpty(response.data.rascunho.dt_frequencia_rascunho);
                if (semRascunhoBase) {
                    this.criarBackupRascunho();
                    return;
                }

                confirm({
                    title: "Rascunho encontrado",
                    content: `Existe um rascunho guardado para esta aula a ${moment(response.data.dt_frequencia_rascunho).format(
                        "DD/MM/YYYY [às] HH:mm"
                    )}. Deseja carregar os dados do rascunho?`,
                    okText: "Sim, carregar",
                    cancelText: "Não",
                    onOk: () => {
                        let presencasRascunho = JSON.parse(response.data.rascunho.presencas_rascunho);
                        /*let ficheiroRascunho = JSON.parse(response.data.ficheiros);*/

                        let presencas = this.state.participantes.map(participante => {
                            var registo = presencasRascunho.find(x => x.id === participante.id);

                            if (registo) {
                                if (registo.presente !== undefined) {
                                    registo.estado = registo.presente ? "P" : "F";
                                }

                                if (registo.estado === "FJ") {
                                    if (registo.tipo) registo.tipo = registo.tipo;
                                    if (registo.ficheiro) registo.ficheiro = registo.ficheiro;
                                    if (registo.variosDias !== undefined) registo.variosDias = registo.variosDias;
                                    if (registo.dataInicio) registo.dataInicio = registo.dataInicio;
                                    if (registo.dataFim) registo.dataFim = registo.dataFim;
                                }

                                return registo;
                            } else {
                                return {
                                    id: participante.id,
                                    estado: undefined,
                                    observacoes: "",
                                    mostrarObservacoes: false
                                };
                            }
                        });

                        this.setState(
                            {
                                presencas: presencas,
                                observacoes: response.data.rascunho.observacoes_rascunho ? response.data.rascunho.observacoes_rascunho : "",
                                aplicar: response.data.rascunho.aplicar_rascunho,
                                presenca: response.data.rascunho.presenca_coletiva_rascunho,
                                falta: response.data.rascunho.falta_coletiva_rascunho,
                                loadingParticipantes: false,
                                ficheiros: response.data.ficheiros
                            },
                            () => {
                                this.criarBackupRascunho();
                            }
                        );
                    },
                    onCancel: this.cancelarRascunho
                });
            })
            .catch(error => {});
    };

    buscarFicheirosRascunho = () => {
        const aulaId = localStorage.getItem("aula_diario");
        if (!aulaId) return;

        axios({
            method: "get",
            url: "/api/aulas/rascunho-frequencia-aula",
            params: { aulaId }
        }).then(res => {
            this.setState({ ficheiros: res.data.ficheiros || [] });
        });
    };

    removerFicheiro = id => {
        const novaLista = this.state.ficheiros.filter(x => x.id !== id);
        this.setState({ ficheiros: novaLista }, () => {
            this.guardarRascunhoFrequencia(id);
        });
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeCheckbox = event => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handlerChangeCheckboxObservacoes = (event, participanteId) => {
        var presencas = this.state.presencas;
        var index = presencas.findIndex(x => x.id === participanteId);
        presencas[index].mostrarObservacoes = event.target.checked;

        this.setState(
            {
                falta: false,
                presenca: false,
                presencas
            },
            () => {
                this.iniciarAutoSave();
            }
        );
    };

    handleChangeParticipante = (event, participanteId) => {
        var presencas = this.state.presencas;
        var index = presencas.findIndex(x => x.id === participanteId);
        presencas[index].observacoes = event.target.value;

        this.setState({ presencas }, () => {
            this.iniciarAutoSave();
        });
    };

    handlerChangeCheckboxPresencaColetiva = event => {
        this.props.form.resetFields();

        const presencas = this.state.participantes.map(participante => {
            var registo = this.state.presencas.find(x => x.id === participante.id);

            if (!participante.transferido && !registo.preenchidoManualmente) registo.estado = event.target.checked ? "P" : undefined;
            return registo;
        });

        const assiduidadesInvalidas = this.state.assiduidadesInvalidas.filter(id => !presencas.find(p => p.id === id && p.estado === "P"));

        this.setState({
            presenca: event.target.checked,
            falta: false,
            presencas,
            assiduidadesInvalidas
        });
    };

    handlerChangeCheckboxFaltaColetiva = event => {
        this.props.form.resetFields();

        const presencas = this.state.participantes.map(participante => {
            var registo = this.state.presencas.find(x => x.id === participante.id);

            if (!participante.transferido && !registo.preenchidoManualmente) registo.estado = event.target.checked ? "F" : undefined;
            return registo;
        });

        const assiduidadesInvalidas = this.state.assiduidadesInvalidas.filter(id => !presencas.find(p => p.id === id && p.estado === "F"));

        this.setState({
            falta: event.target.checked,
            presenca: false,
            presencas,
            assiduidadesInvalidas
        });
    };

    handlerChangeCheckboxPresencas = (event, participanteId) => {
        var presencas = this.state.presencas;
        var index = presencas.findIndex(x => x.id === participanteId);
        presencas[index].presente = event.target.checked;

        this.setState({
            falta: false,
            presenca: false,
            presencas
        });
    };

    handlerChangeSelect = (value, participanteId) => {
        this.setState(
            prevState => {
                const presencas = prevState.presencas.map(presenca =>
                    presenca.id === participanteId
                        ? {
                              ...presenca,
                              estado: presenca.estado === value ? undefined : value,
                              preenchidoManualmente: presenca.estado !== value
                          }
                        : presenca
                );

                const assiduidadesInvalidas = this.state.assiduidadesInvalidas.filter(id => !presencas.find(p => p.id === id && p.estado));

                return {
                    presencas,
                    falta: false,
                    presenca: false,
                    assiduidadesInvalidas
                };
            },
            () => {
                const presenca = this.state.presencas.find(x => x.id === participanteId);
                if (presenca && presenca.estado !== "FJ") {
                    const ficheiroAluno = this.state.ficheiros.find(x => x.id_aluno === participanteId);
                    if (ficheiroAluno) {
                        this.removerFicheiro(ficheiroAluno.id);
                    }
                }
            }
        );
    };

    handlerChangeCheckbox = (event, participanteId) => {
        var presencas = this.state.presencas;
        var index = presencas.findIndex(x => x.id === participanteId);
        presencas[index].confirmada = event.target.checked;

        this.setState({
            falta: false,
            presenca: false,
            presencas
        });
    };

    listar = () => {
        this.setState(
            {
                loadingParticipantes: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/detalhe-assiduidade",
                    timeout: 60 * 10 * 1000,
                    params: {
                        aulaId: localStorage.getItem("aula_diario")
                    }
                })
                    .then(response => {
                        if (!response.data.evento.presenca && !response.data.evento.falta && !response.data.evento.presencas) {
                            let presencas = response.data.evento.participantes.map(participante => {
                                return {
                                    id: participante.id,
                                    estado: undefined,
                                    observacoes: "",
                                    mostrarObservacoes: false
                                };
                            });

                            this.setState(
                                {
                                    dt_inicio: response.data.evento.dt_inicio,
                                    presencas,
                                    participantes: response.data.evento.participantes,
                                    observacoes: response.data.evento.observacoes ? response.data.evento.observacoes : "",
                                    loadingParticipantes: false
                                },
                                () => {
                                    this.carregarRascunhoFrequencia();
                                }
                            );
                        } else {
                            let presencas = JSON.parse(response.data.evento.presencas);
                            if (presencas.length === 0)
                                presencas = response.data.evento.participantes.map(participante => {
                                    return {
                                        id: participante.id,
                                        estado: undefined,
                                        observacoes: "",
                                        mostrarObservacoes: false
                                    };
                                });
                            else
                                presencas = response.data.evento.participantes.map(participante => {
                                    var registo = presencas.find(x => x.id === participante.id);
                                    if (registo) {
                                        if (registo.presente) registo.estado = registo.presente ? "P" : "F";

                                        return registo;
                                    } else
                                        return {
                                            id: participante.id,
                                            estado: undefined,
                                            observacoes: "",
                                            mostrarObservacoes: false
                                        };
                                });

                            this.setState(
                                {
                                    dt_inicio: response.data.evento.dt_inicio,
                                    presenca: response.data.evento.presenca,
                                    falta: response.data.evento.falta,
                                    presencas,
                                    observacoes: response.data.evento.observacoes ? response.data.evento.observacoes : "",
                                    participantes: response.data.evento.participantes,
                                    loadingParticipantes: false,
                                    ficheiros: response.data.ficheiros
                                },
                                () => {
                                    this.carregarRascunhoFrequencia();
                                }
                            );
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                    });
            }
        );
    };

    verificar = () => {
        const perfis = [1, 3];
        const isPerfilIsento = perfis.includes(this.context.perfil.id);
        const podeAvancar = isPerfilIsento || this.verificarAssiduidadeTotalmentePreenchida();

        if (!podeAvancar) return;

        if (!this.state.aplicar) {
            this.guardarPresencas();
            return;
        }

        this.verificarFrequenciaExistente();
    };

    verificarAssiduidadeTotalmentePreenchida = () => {
        const { presencas } = this.state;
        const alunosTransferidosIds = this.state.participantes.filter(p => p.transferido).map(a => a.id);

        const idsInvalidos = presencas.filter(p => !alunosTransferidosIds.includes(p.id) && !p.estado).map(p => p.id);

        if (idsInvalidos.length > 0) {
            this.setState({ assiduidadesInvalidas: idsInvalidos });

            warning({
                title: "Frequência incompleta",
                content:
                    "Existem alunos com frequência por preencher. Por favor, verifique os nomes assinalados a vermelho antes de guardar.",
                okText: "Fechar"
            });

            return false;
        }

        this.setState({ assiduidadesInvalidas: [] });
        return true;
    };

    guardarPresencas = () => {
        if (
            this.state.presenca ||
            this.state.falta ||
            this.state.presencas.filter(x => x.estado || x.observacoes).length ||
            this.state.observacoes
        ) {
            this.setState({ iconLoading: true });

            var item = new FormData();
            item.append("id", this.props.aulaId);
            item.append("cursoId", localStorage.getItem("codigo_curso"));
            item.append("presenca", this.state.presenca);
            item.append("falta", this.state.falta);
            item.append("presencas", JSON.stringify(this.state.presencas));
            item.append("observacoes", this.state.observacoes);
            item.append("aplicar", this.state.aplicar);

            const participantes = this.state.presencas.filter(precensa => precensa.ficheiro != null);

            participantes.forEach(participante => {
                item.append(`ficheiro_${participante.id}`, participante.ficheiro[0]);
            });

            let filesRascunho = [];
            this.state.ficheiros.forEach(ficheiro => {
                if (ficheiro.is_rascunho) filesRascunho.push({ ficheiro });
            });

            item.append("filesSave", JSON.stringify(filesRascunho));

            axios({
                method: "put",
                url: "/api/aulas/alterar-assiduidade",
                data: item,
                timeout: 60 * 30 * 1000
            })
                .then(() => {
                    openNotificationWithIcon("success", "Sucesso", "Assiduidade guardada!");
                    var presencas = this.state.presencas;
                    this.state.presencas.map(presenca => {
                        var index = presencas.findIndex(x => x.id === presenca.id);
                        if (presencas[index].confirmada) presencas[index].pendente = false;
                    });

                    this.setState({
                        presencas,
                        iconLoading: false,
                        aplicar: false
                    });
                    this.props.disponibilizarExcluir();

                    this.backupRascunho = null;

                    // Atualizar contexto global
                    if (this.context.atualizarState) {
                        this.context.atualizarState({
                            existeRascunhoFrequenciaGuardado: false
                        });
                    }
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", "Não foi guardar assiduidade!");
                    this.setState({ iconLoading: false, aplicar: false });
                });
        } else {
            openNotificationWithIcon("info", "Informação", "Não existem dados a serem guardados");
        }
    };

    verificarFrequenciaExistente = () => {
        axios({
            method: "get",
            url: "/api/aulas/verificar-existencia-frequencia",
            params: {
                aulaId: this.props.aulaId,
                cursoId: localStorage.getItem("codigo_curso")
            },
            timeout: 60 * 30 * 1000
        })
            .then(response => {
                if (response.data)
                    confirm({
                        title: `Aula(s) ${response.data} já possui frequência, deseja continuar?`,
                        okText: "Confirmar",
                        okType: "Cancelar",
                        onOk: () => {
                            this.guardarPresencas();
                        }
                    });
                else this.guardarPresencas();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi verificar estado das aulas posteriores.");
            });
    };

    montarParticipante = presenca => {
        var participante = this.state.participantes.find(x => x.id === presenca.id);
        const assiduidadeInvalida = this.state.assiduidadesInvalidas.includes(participante.id);

        if (participante)
            return (
                <div className="participante">
                    <div className="info-participante">
                        <div className="container-img">
                            {participante.foto ? (
                                <img src={participante.foto} />
                            ) : (
                                participante.nome !== "" && <InitialsAvatar name={participante.nome} />
                            )}
                        </div>
                        <div className={`info ${assiduidadeInvalida ? "assiduidade-invalida" : ""}`}>
                            <span className="nome">{participante.nome}</span>
                            <p className="numero">{participante.numero}</p>
                        </div>
                        {presenca.pendente && (
                            <div>
                                <Icon type="warning" className="estado-pendente" title="Aguarda validação" />
                            </div>
                        )}
                    </div>
                </div>
            );
    };

    adicionarDetalhe = (id, detalhe) => {
        var index = this.state.presencas.findIndex(x => x.id === id);
        var presencas = this.state.presencas;
        presencas[index].tipo = detalhe.tipo;
        presencas[index].ficheiro = detalhe.ficheiro;
        presencas[index].variosDias = detalhe.variosDias;
        presencas[index].dataInicio = detalhe.dataInicio;
        presencas[index].dataFim = detalhe.dataFim;

        this.setState(
            {
                presencas,
                visivel: false
            },
            () => {
                this.guardarRascunhoFrequencia();
            }
        );
    };

    render() {
        const { TextArea } = Input;
        const {
            //DRAWER PRESENÇAS
            falta,
            presenca,
            presencas,
            participantes,
            observacoes,
            aplicar,
            ficheiro,
            //LOADING
            iconLoading,
            //DRAWER DETALHE
            visivel,
            info
        } = this.state;

        const { dtInicio } = this.props;

        const hoje = moment();
        hoje.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        dtInicio.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

        const bloquear = dtInicio.isAfter(hoje);

        const acesso = this.context.acessos?.find(x => x.func === 17);

        const alunosTransferidosIds = participantes.filter(p => p.transferido).map(a => a.id);

        const algumPreenchido = presencas.some(p => !alunosTransferidosIds.includes(p.id) && p.estado);

        return (
            <>
                <div className="bloco-presencial">
                    <div className="bloco-frequencia-diario" style={{ boxShadow: "none" }}>
                        <div className="listagem-participantes" style={{ marginTop: 0 }}>
                            <Form className="form-presencas" layout="horizontal">
                                <div className="bloco bloco-opcoes">
                                    <div>
                                        <Form.Item className="form-item-checkbox" style={{ marginBottom: 0 }}>
                                            <Checkbox
                                                name="presenca"
                                                checked={presenca}
                                                disabled={bloquear || !acesso?.update}
                                                onChange={this.handlerChangeCheckboxPresencaColetiva}
                                            >
                                                Presença coletiva
                                            </Checkbox>
                                            <Checkbox
                                                name="falta"
                                                checked={falta}
                                                disabled={bloquear || !acesso?.update}
                                                onChange={this.handlerChangeCheckboxFaltaColetiva}
                                            >
                                                Falta coletiva
                                            </Checkbox>
                                        </Form.Item>
                                    </div>
                                    <div className="bloco-totais">
                                        <span className="presencas">
                                            P: <strong>{presencas.filter(x => x.estado === "P").length}</strong>
                                        </span>
                                        <span className="faltas">
                                            F: <strong>{presencas.filter(x => x.estado === "F").length}</strong>
                                        </span>
                                        <span className="justificadas">
                                            FJ: <strong>{presencas.filter(x => x.estado === "FJ").length}</strong>
                                        </span>
                                    </div>
                                </div>
                                <div className="bloco">
                                    <Form.Item>
                                        <div className="listagem-presencas">
                                            {presencas.map((presenca, index) => (
                                                <div key={presenca.id} className="item-presenca">
                                                    <div className="header">
                                                        {this.montarParticipante(presenca)}
                                                        <div className="opcao">
                                                            <div className="bloco-opcoes">
                                                                <button
                                                                    className={`btn-presenca ${presenca.estado === "P" ? "ativo" : ""}`}
                                                                    disabled={bloquear || !acesso?.update}
                                                                    onClick={() => this.handlerChangeSelect("P", presenca.id)}
                                                                >
                                                                    P
                                                                </button>
                                                                <button
                                                                    className={`btn-falta ${presenca.estado === "F" ? "ativo" : ""}`}
                                                                    disabled={bloquear || !acesso?.update}
                                                                    onClick={() => this.handlerChangeSelect("F", presenca.id)}
                                                                >
                                                                    F
                                                                </button>
                                                                <button
                                                                    className={`btn-justificada ${presenca.estado === "FJ" ? "ativo" : ""}`}
                                                                    disabled={bloquear || !acesso?.update}
                                                                    onClick={() => this.handlerChangeSelect("FJ", presenca.id)}
                                                                >
                                                                    FJ
                                                                </button>
                                                            </div>
                                                            {presenca.estado === "FJ" && (
                                                                <Form.Item>
                                                                    <Link
                                                                        to="#"
                                                                        className="link-detalhe"
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                visivel: true,
                                                                                info: presenca,
                                                                                ficheiro: (this.state.ficheiros || []).filter(
                                                                                    x => x.id_aluno === presenca.id
                                                                                )
                                                                            })
                                                                        }
                                                                    >
                                                                        <Icon type="plus" />
                                                                        {!presenca.tipo ? "Adicionar" : "Alterar"} detalhe
                                                                    </Link>
                                                                </Form.Item>
                                                            )}
                                                            {presenca.pendente && (
                                                                <Form.Item>
                                                                    <Checkbox
                                                                        name="aplicar"
                                                                        checked={presenca.confirmada}
                                                                        onChange={e => this.handlerChangeCheckbox(e, presenca.id)}
                                                                    >
                                                                        Confirmar decisão
                                                                    </Checkbox>
                                                                </Form.Item>
                                                            )}
                                                            <Checkbox
                                                                name="observacoes"
                                                                checked={presenca.mostrarObservacoes}
                                                                disabled={bloquear || !acesso?.update}
                                                                onChange={e => this.handlerChangeCheckboxObservacoes(e, presenca.id)}
                                                            >
                                                                Mostrar Observações
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                    {presenca.mostrarObservacoes === false ? (
                                                        <></>
                                                    ) : (
                                                        <div className="body body-block">
                                                            <Form.Item label="Observações">
                                                                <TextArea
                                                                    name="observacoes"
                                                                    disabled={bloquear || !acesso?.update}
                                                                    rows={4}
                                                                    style={{ height: 100 }}
                                                                    value={presenca.observacoes}
                                                                    onChange={e => this.handleChangeParticipante(e, presenca.id)}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </Form.Item>
                                    <Form.Item label="Observações gerais">
                                        <TextArea
                                            name="observacoes"
                                            rows={4}
                                            style={{ height: 100 }}
                                            value={observacoes}
                                            disabled={bloquear || !acesso?.update}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Checkbox
                                            name="aplicar"
                                            checked={aplicar}
                                            disabled={bloquear || !acesso?.update}
                                            onChange={this.handleChangeCheckbox}
                                        >
                                            Aplicar esta frequência a todas as aulas posteriores já registadas <strong>neste dia</strong>.
                                        </Checkbox>
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                        {!bloquear && acesso?.update && (
                            <div style={{ width: "100%" }}>
                                <Link
                                    className="botao-principal"
                                    to="#"
                                    disabled={iconLoading || !algumPreenchido}
                                    onClick={this.verificar}
                                >
                                    {iconLoading ? <Icon type="loading" /> : null}
                                    Salvar
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
                <DrawerDetalhe
                    visivel={visivel}
                    info={info}
                    ficheiro={ficheiro}
                    onClose={() => this.setState({ visivel: false })}
                    adicionarDetalhe={this.adicionarDetalhe}
                    removerFicheiro={this.removerFicheiro}
                />
            </>
        );
    }
}

const FormFrequencia = Form.create({ name: "form-frequencia" })(Frequencia);

export default FormFrequencia;
